import React from "react";
import { FormField } from "../../UI/DesignStandards";

export const TeamDetailsSection = ({
  teamName,
  onTeamNameChange,
  onTeamNameBlur,
  errors = {},
  selectedEvent,
}) => {
  // Team name is only required for team events (bowlerQuantity > 2)
  const isRequired = selectedEvent?.bowlerQuantity > 2;

  return (
    <div className="space-y-4">
      <h3 className="heading-display text-lg">Team Details</h3>

      <FormField
        label="Team Name"
        type="text"
        value={teamName}
        onChange={(e) => onTeamNameChange(e.target.value)}
        onBlur={(e) => onTeamNameBlur && onTeamNameBlur(e.target.value)}
        error={errors.teamName}
        placeholder="Team name"
        required={isRequired}
        maxLength={50}
      />
    </div>
  );
};
